import { Component, OnInit, Input } from "@angular/core";
import { CommonService } from "../service/common.service";
import { YoyakuService } from "../service/yoyaku.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "yoyaku-conditions-edit-app",
  templateUrl: "./yoyaku-conditions-edit.component.html",
  styleUrls: ["yoyaku-conditions-edit.component.css"],
})
export class YoyakuConditionsEditModalComponent {
  @Input() yoyakuData: any[];
  @Input() conditionsList: any[];
  @Input() selected: any[];

  div1Id: number = null;
  div2Id: number = null;
  maxCount: any = null;
  maxPoint: any = null;
  disabled: boolean = false;
  chackInvalid: boolean = false;
  invalidFlg: number = null;
  memo: string = "";
  selectedDivisionId: number = null;
  selectedConditionId: string = null;
  duplicationCount: number = null;
  submitDisabled: boolean = false;

  constructor(
    public commonService: CommonService,
    private yoyakuService: YoyakuService,
    public activeModal: NgbActiveModal
  ) {}
  updYoyakuDataKeys: any = [
    "m_yoyaku_id",
    "m_division_1_id",
    "m_division_1_nm",
    "m_division_2_id",
    "m_division_2_nm",
    "start_time_definition",
    "end_time_definition",
    "max_yoyaku_count",
    "max_yoyaku_point",
    "conditions_group_kbn",
    "conditions_id",
    "sum_count",
    "sum_point",
    "yoyaku_memo",
    "display_memo",
    "t_yoyaku_history_id",
    "invalid_flg",
  ];
  ret: any = {
    status: "",
    updYoyakuData: [],
  };
  //起動時処理
  ngOnInit(): void {
    //モーダル内セレクトボックスの初期値設定
    // this.getList();
    this.clearData();
    this.checkData();
    this.changeInvalid();
  }
  clearData(): void {
    this.div1Id = null;
    this.div2Id = null;
    this.maxCount = null;
    this.maxPoint = null;
    this.disabled = false;
    this.memo = null;
    this.chackInvalid = false;
    this.invalidFlg = 0;
    this.memo = "";
    if (this.yoyakuData["conditions_id"] == null) {
      this.selectedConditionId = null;
    } else {
      this.selectedConditionId =
        this.yoyakuData["conditions_group_kbn"] +
        "_" +
        this.yoyakuData["conditions_id"];
    }
  }
  //読み込み時
  checkData() {
    var division = this.yoyakuData["division_id"].split("_");
    this.div1Id = division[0];
    this.div2Id = division[1] == 0 ? null : division[1];
    this.maxCount = this.yoyakuData["max_yoyaku_count"];
    this.maxPoint = this.yoyakuData["max_yoyaku_point"];
    this.memo = this.yoyakuData["yoyaku_memo"];
    if (
      this.yoyakuData["sum_count"] != 0 ||
      this.yoyakuData["m_yoyaku_id"] == null
    ) {
      this.disabled = true;
    }
    if (
      this.yoyakuData["invalid_flg"] == "0" ||
      this.yoyakuData["invalid_flg"] == null
    ) {
      this.chackInvalid = false;
    } else {
      this.chackInvalid = true;
    }
    this.duplicationCount = this.yoyakuData["dup_count"];
    this.checkYoyaku();
  }
  save(): void {
    this.commonService.modalOpens(
      50001,
      //保存してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          let param = {
            id: this.yoyakuData["m_yoyaku_id"],
            yoyakuhyo_id: this.yoyakuData["m_yoyakuhyo_id"],
            yoyaku_date: this.yoyakuData["yoyaku_date"],
            timeaxis_id: this.yoyakuData["timeaxis_id"],
            division_1_id: this.div1Id,
            division_2_id: this.div2Id,
            maxCount: this.maxCount,
            maxPoint: this.maxPoint,
            t_conditions_id: this.selectedConditionId,
            invalidFlg: this.invalidFlg,
            memo: this.memo,
          };
          this.yoyakuService.saveYoyakuData(param).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10001, (modalresult) => {
                  if (modalresult == "OK") {
                    this.ret.status = "Update";
                    this.ret.updYoyakuData = res["fuel_results"]["data"][0];
                    this.createResultData(
                      this.yoyakuData,
                      this.ret.updYoyakuData
                    );
                    this.activeModal.close(this.ret);
                  }
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {}
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            }
          );
        } else {
          //
        }
      }
    );
  }
  //予約データを削除
  delete() {
    this.commonService.modalOpens(
      50002,
      //削除してもよろしいですか？
      (modalresult) => {
        if (modalresult == "OK") {
          let param = {
            id: this.yoyakuData["m_yoyaku_id"],
          }
          this.yoyakuService.deleteYoyakuData(param).subscribe(
            (res: Response) => {
              if (res["fuel_status"] == "OK") {
                this.commonService.modalOpens(10002, (modalresult) => {
                  if (modalresult == "OK") {
                    this.ret.status = "Delete";
                    this.ret.updYoyakuData = res["fuel_results"]["data"][0];
                    this.createResultData(
                      this.yoyakuData,
                      this.ret.updYoyakuData
                    );
                    this.activeModal.close(this.ret);
                  }
                });
              } else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(
                  res["fuel_message"],
                  (modalresult) => {}
                );
              } else {
                this.commonService.modalOpens(11003, (modalresult) => {});
              }
            },
            (error) => {
              this.commonService.modalOpens(error, (modalresult) => {});
            }
          );
        } else {
        }
      }
    );
  }
  createResultData(data: any, updData: any): void {
    let result = Array();
    var keys = Object.keys(data);
    var length = Object.keys(data).length;
    for (var i = 0; i <= length; i++) {
      var keyName = keys[i];
      var item = this.updYoyakuDataKeys.filter((item) => item == keyName);
      if (item.length > 0) {
        if (updData === undefined) {
          result[keyName] = null;
        } else {
          result[keyName] = updData[keyName];
        }
      } else {
        result[keyName] = data[keyName];
      }
    }
    this.ret.updYoyakuData = result;
  }
  //無効フラグON・OFF
  changeInvalid() {
    if (this.chackInvalid == true) {
      this.invalidFlg = 1;
    } else {
      this.invalidFlg = 0;
    }
  }
  checkYoyaku(): void {
    this.replaceNumber(1);
    this.replaceNumber(2);
    if(this.checkCount()){
      this.submitDisabled = true;
    }else if(this.checkDuplication()){
      this.submitDisabled = true;
    }else if(this.checkNumber()){
      this.submitDisabled = true;
    }else{
      this.submitDisabled = false;
    }
  }
  checkDuplication(): boolean {
    if(this.yoyakuData["m_yoyaku_id"] != null && this.yoyakuData["m_yoyaku_id"] != "" && this.yoyakuData["m_yoyaku_id"] != undefined){
      return false;
    } else {
      if(this.duplicationCount>0){
        return true;
      } else {
        return false;
      }
    }
  }
  checkCount(): boolean {
    // if(this.yoyakuData["m_yoyaku_id"] == null){
    //   return false;
    // } else {
    //   if(this.yoyakuData["sum_count"] != null && this.yoyakuData["sum_count"] != ""){
    //     if(this.yoyakuData["sum_count"] > this.maxCount){
    //       return true;
    //     } else {
    //       if(this.yoyakuData["sum_point"] != null && this.yoyakuData["sum_point"] != ""){
    //         if(this.yoyakuData["sum_point"] > this.maxPoint){
    //           return true;
    //         } else {
    //           return false;
    //         }
    //       }else {
    //         return false;
    //       }
    //     }
    //   }
    // }
    return false;
  }
  replaceNumber(mode):void {
    if(mode == 1){
      if(this.maxCount == ""){
        this.maxCount = null;
      }
    } else {
      if(this.maxPoint == ""){
        this.maxPoint = null;
      }
    }
  }
  checkNumber(): boolean {
    if(this.maxPoint == null){
      if(this.maxCount == null){
        return false;
      } else {
        let num2 = this.maxCount;
        let match2 = num2.match(/^[0-9]+$/);
        if(!match2) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      let num1 = this.maxPoint;
      let match1 = num1.match(/^[0-9]+$/);
      if(!match1) {
        return true;
      } else {
        return false;
      }
    }
  }
  //キャンセル時
  Cancel() {
    this.ret.status = "Cancel";
    this.activeModal.close(this.ret);
  }
}



// WEBPACK FOOTER //
// ./src/app/a2103-yoyaku-register/yoyaku-conditions-edit.component.ts